module.exports = __webpack_public_path__ + "img/avon-fighting-breast-cancer-11.9cadc8ea.jpg";